import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import ReactHelmet from 'react-helmet';

import { ShowButton } from 'component/reuse/show';
import {SDK_VERSION} from 'component/reuse/js_code';


class Page extends React.Component {
  
  render (){
    const {account_key} = this.props.match.params;

      // var script = document.createElement('script'); script.type = 'text/javascript'; script.src = "https://divshow.bytebeacon.com/static/sdk/0.0.13/divshow_builder.min.js?api_key=bgzz3muosb"; document.body.appendChild(script);
      // check the SDK_VERSION
      
      const demo_info = {
      'thryv': ["cwn5jvakp", "https://www.thryv.com/"],
      'bettercloud': ["", "https://www.bettercloud.com"],
      'alation': ["", "https://www.alation.com"],
      'granicus': ["", "https://granicus.com"],
      'cloudcampaign': ["", "https://cloudcampaign.io"],
      
      'placecard': ["vo8pvjtju", "https://www.placecard.me"],
      'kinetics': ["", "https://kineticsoftware.com"],
      'mindbody': ["", "https://www.mindbodyonline.com"],
      'zirra': ["", "https://www.zirra.com"],
      
      '': ["", ""],
    }[account_key]

    if (demo_info === undefined){
      this.props.history.push("/");
    }

    const [show_xid, iframe_url] = demo_info;

    return (

      <div style={{height: "500%", width: "100%", margin:'0px', padding:'0px', overflow:'hidden'}} >
        <ReactHelmet>
          <script src={"https://divshow.bytebeacon.com/static/sdk/" + SDK_VERSION + "/divshow.min.js?show_id=" + show_xid}></script>
        </ReactHelmet>

        <div className="row my-0 py-0">
          <div className="col-md-2">
            <Link to="/" className="btn bg-quaternary text-white">DivShow Home</Link>
          </div>
          <div className="col-md-8">
            <div className="animated pulse infinite text-center my-2">
              <ShowButton show_xid={show_xid} type="small" />
            </div>
          </div>        
        </div>
        
        <iframe src={iframe_url} title="demo-shell" style={{height: "150%", width: "100%", margin:'0px', padding:'0px', overflow:'hidden'}} frameBorder="0" scrolling="yes"></iframe>
      </div>
    )
  }
}

export default withRouter(Page);